import { createApi, save, toUrlSearchParams } from "./common";

const salesApi = createApi(process.env.REACT_APP_SALES_API_URL);
export default salesApi;

export const findCustomers = () => salesApi.get("/customers");

export const findSaleHistory = (tkt) => salesApi.get(`/history/${tkt}`);

export const findSales = (params) =>
  salesApi.get(`/?${toUrlSearchParams(params)}`);

export const findSalesAgents = () => salesApi.get("/sales-agents");

export const findSalesAggregates = (params) =>
  salesApi.get(`/sales-aggregates?${toUrlSearchParams(params)}`);

export const findSuppliers = () => salesApi.get("/suppliers");

export const saveCustomer = save(salesApi)("/customers");

export const saveSale = save(salesApi)("");

export const saveSupplier = save(salesApi)("/suppliers");
